import { useEffect, useState } from "react";

export function useDeviceOrientation() {
  // Initialize to a stable value so this is SSR-safe and hydration-safe; the
  // real orientation is resolved on mount, where `window` exists.
  const [orientation, setOrientation] = useState<"portrait" | "landscape">(
    "portrait",
  );

  useEffect(() => {
    const mql = window.matchMedia("(orientation: portrait)");
    setOrientation(mql.matches ? "portrait" : "landscape");

    const handler = (e: MediaQueryListEvent) => {
      setOrientation(e.matches ? "portrait" : "landscape");
    };

    mql.addEventListener("change", handler);

    return () => {
      mql.removeEventListener("change", handler);
    };
  }, []);

  return orientation;
}
